import { render } from "./BannerCreate.vue?vue&type=template&id=52db4cda&scoped=true"
import script from "./BannerCreate.vue?vue&type=script&lang=js"
export * from "./BannerCreate.vue?vue&type=script&lang=js"

import "./BannerCreate.vue?vue&type=style&index=0&id=52db4cda&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52db4cda"]])

export default __exports__